import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { Message, MessageBox } from 'element-ui'
import getField from '@/utils/getField'
// import store from '../store'
// import { getToken } from '@/utils/auth'

// axios
const service = axios.create({
  baseURL: process.env.BASE_API, // api base_url
  timeout: 0, //105000, // request timeout
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  transformRequest: [function (data, headers) {
    // headers['Authorization'] = auth()
    return JSON.stringify(data)
  }]
})

var application = process.env.APPLICATION

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  /* if (store.getters.token) {
    // Пусть каждый запрос переносит токен - ['X-Token'] в качестве настраиваемого ключа. Измените его в соответствии с реальной ситуацией.
    config.headers['X-Token'] = getToken()
  } */
  config.headers['X-Application'] = application
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(
  /**
   * Следующий комментарий указывает, что статус запроса указывается специальным кодом в ответе.
   * Когда код возвращает следующее, это указывает на наличие проблемы с разрешениями, выход из системы и возврат на страницу входа в систему.
   * Если вы хотите использовать логику идентификации кода состояния xmlhttprequest, можно записать следующую ошибку
   * Следующие коды являются примерами, пожалуйста, измените их в сочетании с самогенерируемыми требованиями, если они вам не нужны, вы можете их удалить.
   */
  response => response.data,
  // response => {
  // /**
  //  * code 20000
  //  */
  // const res = response.data
  // if (res.code !== 20000) {
  //   /* Message({
  //     message: res.message,
  //     type: 'error',
  //     duration: 5 * 1000
  //   }) */
  //
  //   // 50008:Недействительный token; 50012:остальные клиенты вошли в систему;  50014:Token истек;
  //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //     // Пожалуйста, внесите MessageBox самостоятельно
  //     // import { Message, MessageBox } from 'element-ui'
  //     /* MessageBox.confirm('Вы вышли из системы, вы можете отменить его на этой странице или войти в систему снова', 'Определено выйти из системы', {
  //       confirmButtonText: 'Повторный вход',
  //       cancelButtonText: 'Отмена',
  //       type: 'warning'
  //     }).then(() => {
  //       store.dispatch('FedLogOut').then(() => {
  //         location.reload()// Чтобы повторно создать объект vue-router, чтобы избежать ошибок
  //       })
  //     }) */
  //   }
  //   return Promise.reject('error')
  // } else {
  //   return response.data
  // }
  // },
  error => {
    console.log('err ' + error) // for debug
    let errorMessage = getField(error, 'response.data.body.exception') || getField(error, 'response.data.exception') || error.message

    let unauthorized = false
    if (error.response !== undefined) {
      switch (error.response.status) {
        case 401: {
          unauthorized = true
          console.error('UNAUTHORIZED!!!!!!')
          const url = error.config.url.replace(error.config.baseURL, '')
          if (!url.startsWith('login/')) {
            store.dispatch('user/resetSession').then(() => {
              location.reload()
            })
          }
          break
        }
        default: {
          break
        }
      }
    }
    // show error for non-401 only and if error is not expected
    if (!unauthorized && !(error.config.expectedErrorCodes || []).includes(error.response.status)) {
      Message({
        message: errorMessage,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)


export function itemEditMixins (prefix) {
  return {
    getItems: function (itemType) {
      return request({
        url: prefix + itemType,
        method: 'get'
      })
    },
    saveItem: function (itemType, data, id) {
      let url = prefix + itemType
      if (id !== undefined) {
        url += '/' + id
      }
      return request({
        url,
        method: 'post',
        data
      })
    },
    checkItemForDelete: function (itemType, id) {
      return request({
        url: prefix + itemType + '/' + id + '/check-delete',
        method: 'get'
      })
    },
    deleteItem: function (itemType, id) {
      return request({
        url: prefix + itemType + '/' + id,
        method: 'delete'
      })
    }
  }
}

export function itemSearchListMixins (prefix) {
  return {
    searchItems (searchFilter, pageRequest = null) {
      let queryString = buildPageRequestQuery(pageRequest)
      return request({
        url: `${prefix}/search` + (queryString.length > 0 ? '?' : '') + queryString,
        method: 'post',
        data: searchFilter
      })
    }
  }
}

export function buildPageRequestQuery (pageRequest) {
  let queryString = ''
  let queryParts = []
  if (pageRequest) {
    if (pageRequest.page && pageRequest.size) {
      let start = (pageRequest.page - 1) * pageRequest.size
      let size = pageRequest.size
      queryParts.push(`start=${start}`)
      queryParts.push(`size=${size}`)
    }
    if (pageRequest.order) {
      queryParts.push(`order=${pageRequest.order}`)
    }
    queryString = queryParts.join('&')
  }
  return queryString
}

// exports

export function request () {
  return service(...arguments)
}



// WEBPACK FOOTER //
// ./src/utils/request.js